import ShButton from '@/components/Helpers/ShButton';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import ConfigurationModalStepOne from './ConfigurationModalStepOne/index';
import ConfigurationModalStepTwo from './ConfigurationModalStepTwo/index';
import ConfigurationModalStepThree from './ConfigurationModalStepThree/index';
import ConfigurationModalStepFour from './ConfigurationModalStepFour/index';
import ConfigurationModalStepFive from './ConfigurationModalStepFive/index';

export default {
  name: 'ConfigurationModal',

  components: {
    ShButton,
    ShModalWindow,
    ConfigurationModalStepOne,
    ConfigurationModalStepTwo,
    ConfigurationModalStepThree,
    ConfigurationModalStepFour,
    ConfigurationModalStepFive,
  },
  props: {
    widgetIdForRequiredNumberVerification: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      step: 1,
      domain: '',
      widgetId: 0,
      numberToBeAssigned: {},
    };
  },

  methods: {
    setDomain(domainName) {
      this.domain = domainName;
    },
  },
  created() {
    if (this.widgetIdForRequiredNumberVerification) {
      this.step = 3;
      this.widgetId = this.widgetIdForRequiredNumberVerification;
    }
  },
};
